import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";
import {
	IQueue,
	IUserQueue,
	ICreateQueueResponse,
	IDeleteQueueResponse,
	IUpdateQueueResponse,
} from "../../types/QueueMapping/QueueMapping";
import { GraphqlQueryResponse } from "@/Common/api/types/GraphqlQueryResponse";

export async function createQueue(locationId: string, input: IQueue) {
	const query = gql`
		mutation createQueue($locationId: String!, $input: QueueInput!) {
			createQueue(locationId: $locationId, input: $input) {
				_id
				name
				locationId
				overflowQueues
				usersByPosition {
					_id
					name
					users {
						_id
						name
					}
				}
			}
		}
	`;

	const variables = {
		locationId,
		input,
	};

	try {
		const response: GraphqlQueryResponse<"createQueue", ICreateQueueResponse> = await apiInstance.post("/graphql", {
			query,
			variables,
		});
		return response.data.data?.createQueue;
	} catch (err) {
		errorLogger(err as Error, { function: "createQueue", message: "Failed to create queue." });
		return null;
	}
}

export async function updateQueue(locationId: string, input: IQueue) {
	const finalInput = {
		...input,
		usersByPosition: input.usersByPosition.map((position) => ({
			...position,
			users: position.users.map((userQueue: IUserQueue) => {
				return typeof userQueue.name === "object"
					? { ...userQueue, name: (userQueue.name as React.ReactElement).props.children[0] }
					: userQueue;
			}),
		})),
	};

	const query = gql`
		mutation updateQueue($locationId: String!, $input: QueueInput!) {
			updateQueue(locationId: $locationId, input: $input) {
				_id
				name
				locationId
				overflowQueues
				usersByPosition {
					_id
					name
					users {
						_id
						name
					}
				}
			}
		}
	`;

	const variables = {
		locationId,
		input: finalInput,
	};

	try {
		const response: GraphqlQueryResponse<"updateQueue", IUpdateQueueResponse> = await apiInstance.post("/graphql", {
			query,
			variables,
		});
		return response.data.data?.updateQueue;
	} catch (err) {
		errorLogger(err as Error, { function: "updateQueue", message: "Failed to update queue." });
		return null;
	}
}

export async function deleteQueue(locationId: string, input: IQueue[]) {
	const query = gql`
		mutation deleteQueue($locationId: String!, $input: [QueueInput]!) {
			deleteQueue(locationId: $locationId, input: $input) {
				locationId
				queues {
					_id
					locationId
					name
					overflowQueues
					usersByPosition {
						_id
						name
						users {
							_id
							name
						}
					}
				}
			}
		}
	`;

	const variables = {
		locationId,
		input,
	};

	try {
		const response: GraphqlQueryResponse<"deleteQueue", IDeleteQueueResponse> = await apiInstance.post("/graphql", {
			query,
			variables,
		});
		return response.data.data?.deleteQueue;
	} catch (err) {
		errorLogger(err as Error, { function: "deleteQueue", message: "Failed to delete queue." });
		return null;
	}
}
